// extracted by mini-css-extract-plugin
export default {"root":"SNN5FF7VRn","rightSide":"iGah4QTYMc","leftSide":"w9TuRkskLb"};